/**
 * Replaces the urls in the article content from the incorrectUrls array with the urls in the replacementUrls array
 *
 * @param {*} articleContent
 * @return {*} 
 */
export const replaceUrls = (articleContent) => {
    let newArticleContent = articleContent;
    incorrectUrls.forEach((incorrectUrl, index) => {
        newArticleContent = newArticleContent.replace(incorrectUrl, replacementUrls[index]);
    });
    return newArticleContent;
}

export const incorrectUrls = [
    '<a href="http://Google Analytics" target="_blank">',
    '<a href="http://www.vodacombusiness.co.za/corporate/solutions/data-storage-and-tracking/live-track?cid=nwrt_9_nwmd_2668" target="_blank">',
    '<a href="http://Google Analytics" target="_blank">Google Analytics&nbsp;</a></strong></p>',
    '<a href="http://%20http//www.vodacom.co.za/vodacom/nxtlvl/nxt-lvl?cid=EB_nwcb_9_nwmd_9930" target="_blank">',
    '<a href="http://www.wantitall.co.za/Nike-Fuel-Band__B007FSEMPY" target="_blank">',
    '<a href="http://xpansys%20http//www.expansys.co.za/jawbone-up-fitness-wristband-tracker-onyx-medium-size-ios-android-246710/" target="_blank">',
    '<a href="http://%20https//itunes.apple.com/gb/app/bitmoji-avatar-emoji-keyboard/id868077558?mt=8" target="_blank">',
    '<a href="http://%20https//vodafone.taleo.net/careersection/2a_sa/moresearch.ftl?lang=en&amp;radiusType=K&amp;location=690470110040&amp;searchExpanded=true&amp;radius=1%27?cid=EB_nwpr_9_nmp_4837" target="_blank">',
    '<a href="http://Tracked URL         http://www.vodacom.co.za/vodacom/megyourday?cid=MG_nwst_9_nmp_3331">',
    '<a href="http://tracked%20url%20http//www.vodacom.co.za/vodacom/megyourday?cid=MG_nwst_9_nmp_3331">',
];

export const replacementUrls = [
    '<a href="https://analytics.google.com/analytics/web/provision/#/provision" target="_blank">Google Analytics</a></strong></p>',
    '<a href="https://www.vodacombusiness.co.za/business/solutions/data-storage-and-tracking/live-track" target="_blank">',
    '<a href="https://analytics.google.com/analytics/web/provision/#/provision" target="_blank">Google Analytics</a></strong></p>',
    '<a href="https://www.vodacom.co.za/vodacom/shopping/v/nxt-lvl" target="_blank">',
    '<a href="https://www.wantitall.co.za/nike/all/p1" target="_blank">',
    '<a href="https://www.expansys.com/" target="_blank">',
    '<a href="https://play.google.com/store/apps/details?id=com.bitstrips.imoji" target="_blank">',
    '<a href="https://www.vodacom.com/careers.php" target="_blank">',
    '<a href="https://www.vodacom.co.za/vodacom/terms/vodacom-rewards-programme">',
    '<a href="https://www.vodacom.co.za/vodacom/terms/vodacom-rewards-programme">',
];
